module.exports = __webpack_public_path__ + "static/img/ent-88.effa14e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-88.jpg
// module id = cacZ
// module chunks = 51